/// <amd-module name="VSSUI/Components/TreeEx/TreeExpand" />
import * as React from "react";
import { Icon, IconSize, IIconProps } from "VSSUI/Icon";
import { css } from "VSSUI/Util";
import { ITreeExpandProps } from "./TreeExpand.Props";

const defaultCollapsedProps: IIconProps = { iconName: "ChevronRightMed" };
const defaultExpandedProps: IIconProps = { iconName: "ChevronDownMed" };

export class TreeExpand extends React.Component<ITreeExpandProps> {
    public render(): JSX.Element {
        const {
            children,
            className,
            depth,
            expanded,
            iconCollapsedProps = defaultCollapsedProps,
            iconExpandedProps = defaultExpandedProps,
            indentationSize = 16
        } = this.props;

        const iconProps = expanded ? iconExpandedProps : iconCollapsedProps;

        return (
            <>
                <Icon
                    {...iconProps}
                    className={css(className, "bolt-tree-expand-button font-size cursor-pointer", !this.props.onToggle && "invisible")}
                    onClick={this.onClick}
                    role="presentation"
                    size={IconSize.small}
                    style={{ marginLeft: depth > 0 ? depth * indentationSize + "px" : undefined }}
                />
                {children}
            </>
        );
    }

    private onClick = (event: React.MouseEvent<HTMLElement>) => {
        if (!event.defaultPrevented) {
            // Only toggle on a lone left button, not when mixed with others.
            // IPhone doesnt pass buttons so we will take 0 as a click.
            if (event.buttons === 1 || event.buttons === 0) {
                if (this.props.onToggle) {
                    this.props.onToggle(event);
                    event.preventDefault();
                }
            }
        }

        this.props.onClick?.(event);
    };
}
